import React from "react";

import { Block } from "baseui/block";
import { Kontainer } from "kanopi-components/Layout/Kontainer";
import {
  ParagraphMedium,
  HeadingLarge,
  HeadingSmall,
} from "kanopi-components/typography";
import { ConfirmationCircle } from "kw/util/ConfirmationCircle";
import { WidthContainer } from "kw/util/ChatFlow/WidthContainer";
import { NavButton } from "kw/components/NavButton/NavButton";
import { navigate } from "@reach/router";
import { FixedFooter } from "kanopi-components/Sticky/FixedFooter";
import { Sektion } from "kanopi-components/Layout/Sektion";

export const PasswordResetRequestSuccessPage = ({
  location,
}: {
  location: unknown;
  children?: React.ReactNode;
}) => {
  const handleDone = () => {
    navigate("/login");
  };
  const email = location?.state?.email || "";
  return (
    <>
      <Kontainer>
        <Block
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingLeft="scale600"
          paddingRight="scale600"
          paddingTop="scale1200"
          paddingBottom="scale1200"
        >
          <WidthContainer>
            <ConfirmationCircle />
            <HeadingSmall marginTop="scale1200" marginBottom="0">
              Forgot your password
            </HeadingSmall>
            <HeadingLarge marginTop="scale400" center>
              We&apos;ve sent you an email
            </HeadingLarge>
            <ParagraphMedium center>
              We&apos;ve sent you an email with instructions on how to reset your
              password to {email}.
            </ParagraphMedium>
            <ParagraphMedium center>
              Please check your spam folder if you can&apos;t find the email in your
              inbox.
            </ParagraphMedium>
          </WidthContainer>
        </Block>
      </Kontainer>
      <FixedFooter>
        <Sektion>
          <Block display="flex" justifyContent="center">
            <NavButton onClick={handleDone}>Done</NavButton>
          </Block>
        </Sektion>
      </FixedFooter>
    </>
  );
};
